export const getTaskCategoryList = state => {
    return state.list
}

export const getTaskCategoryDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/taskCategory/getters.js